export default color => color.indexOf('#') === 0;



// WEBPACK FOOTER //
// ./src/client/js/view/utils/is-hex-color.js